import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";
import AuthAPI from "../../Api/authApi";

export const forgotPassword = createAsyncThunk("forgot/forgotPassword",async (email, thunkAPI) => {
    try {
      const response = await AuthAPI.forgotPassword(email);
      const message=(response.message)
      thunkAPI.dispatch(setMessage(message))
      return response;
    } catch (error) {
      const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      thunkAPI.dispatch(setMessage(message))
      return thunkAPI.rejectWithValue(message)
    }
  }
); 

const initialState = {
  success: null,
  error: null,
};

const forgotSlice = createSlice({
  name: "forgot",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(forgotPassword.fulfilled, (state) => {
        state.success = true;
        state.error = null;
      })
      .addCase(forgotPassword.rejected, (state, action) => {
        state.success = false;
        state.error = action.payload;  
      });
  },
});

const { reducer } = forgotSlice;
export default reducer;
